import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export async function GetForgetPasswordService(params) {
  const res = await api.get(routes.FORGET_PASSWORD, { params: params });

  return res;
}
